import { PublicClientApplication, type Configuration } from "@azure/msal-browser";

/**
 * MSAL.js config for the Admin API app (design.md D2: two Entra app
 * registrations — SPA public client + Admin API `api://...` exposing scope
 * `Admin.Access` and app roles Operador/Consulta). All three IDs come from
 * Vite env vars (see `.env.example`) and are PLACEHOLDER values until task
 * 5.1 (Entra app registrations, Jose Luis Arcila) is complete — the SPA
 * still builds/lints/tests without real values, it just cannot log in.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_SPA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID}`,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    // sessionStorage (not localStorage): tokens should not persist across
    // browser restarts on shared operator machines.
    cacheLocation: "sessionStorage",
  },
};

/** Dedicated MSAL redirect bridge used only by silent iframe token acquisition. */
export const silentAuthRedirectUri = "/auth/redirect.html";

/** Single scope requested for every acquireToken call — the Admin API's `Admin.Access` scope. */
export const apiRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE],
};

/** Shared MSAL instance for the whole SPA (imported by main.tsx's MsalProvider and api/client.ts). */
export const msalInstance = new PublicClientApplication(msalConfig);
